// extracted by mini-css-extract-plugin
module.exports = {"singleAdmin":"SingleAdmin_singleAdmin__4I5eq","adminName":"SingleAdmin_adminName__2B5MW"};